import { Navigate } from 'react-router-dom';

import { useSession } from '@/lib/auth/session';
import { hrefOf, menuFor, WORK_SPACE } from '@/lib/menu';
import { SAFE_APP_MENU_KEYS } from '@/lib/safeApp';
import { useSelectedSite } from '@/lib/useSelectedSite';

/**
 * 「보미건설 안전관리」 앱의 홈 (DOC-140 · 사용자 결정 2026-10-29 「안전만 보이게」).
 *
 * <p>위젯 대시보드 대신 <b>고른 현장의 첫 안전 화면</b>으로 곧장 보낸다 — 협력사(외주)는 「안전」(TBM·교육),
 * 그 밖의 계정(감리·직원·다른 갈래)은 「안전 점검」. 어느 쪽이 서는지는 사이드바와 같은 `menuFor` 가 정한다 —
 * 여기서 갈래를 다시 판정하면 메뉴에는 없는 곳으로 보내는 날이 온다.
 */
export function SafeAppHome() {
  const { current, partyType, pending } = useSelectedSite();
  const session = useSession();

  if (pending) {
    return <p className="py-6 text-center text-ui-sm" style={{ color: 'var(--text-muted)' }}>불러오는 중입니다…</p>;
  }

  if (current === undefined) {
    return (
      <p className="py-6 text-center text-ui-sm" style={{ color: 'var(--text-muted)' }}>
        배정된 현장이 없습니다.
      </p>
    );
  }

  const first = menuFor(partyType, session.data?.vendorKinds ?? [], WORK_SPACE, () => false, SAFE_APP_MENU_KEYS)
    .flatMap((group) => group.items)[0];
  const to = first === undefined ? null : hrefOf(first, current.id);

  if (to === null) {
    return (
      <p className="py-6 text-center text-ui-sm" style={{ color: 'var(--text-muted)' }}>
        이 현장에는 안전 업무가 없습니다.
      </p>
    );
  }

  return <Navigate to={to} replace />;
}
